import React, { useEffect } from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EFPicture from '@elem/compCommon/EFPicture';
import EcoButton from 'eco-design/base/eco-button';
import { getIsPadWidth } from '@elem/utils/devices';

import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Comp() {
    const { t } = useLang('theProduct.SectionA2');
    const isMobile = getIsPadWidth();
    let innerHeight = 1080;

    if (typeof window !== 'undefined') {
        innerHeight = window?.innerHeight;
    }

    const productList = [
        {
            title: t('product_title_1'),
            desc: t('product_desc_1'),
            lChildren: t('product1_button_text'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744280687659/charger_section3_1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744280687475/charger_section3_1_h5.jpg',
            link: 'https://jp.ecoflow.com/products/delta-2-max-portable-power-station',
            icons: [
                {
                    title: t('product1_icon_title_1'),
                    desc: t('product1_icon_desc_1'),
                    icon: 'https://websiteoss.ecoflow.com/upload/image/1744104788072/charger_section3_1.svg',
                },
                {
                    title: t('product1_icon_title_2'),
                    desc: t('product1_icon_desc_2'),
                    icon: 'https://websiteoss.ecoflow.com/upload/image/1744104788440/charger_section3_2.svg',
                },
                {
                    title: t('product1_icon_title_3'),
                    desc: t('product1_icon_desc_3'),
                    icon: 'https://websiteoss.ecoflow.com/upload/image/1744265808012/charger_section3_3.svg',
                },
                {
                    title: t('product1_icon_title_4'),
                    desc: t('product1_icon_desc_4'),
                    icon: 'https://websiteoss.ecoflow.com/upload/image/1744280417312/charger_section3_4.svg',
                },
                {
                    title: t('product1_icon_title_5'),
                    desc: t('product1_icon_desc_5'),
                    icon: 'https://websiteoss.ecoflow.com/upload/image/1744104788901/charger_section3_5.svg',
                },
                {
                    title: t('product1_icon_title_6'),
                    desc: t('product1_icon_desc_6'),
                    icon: 'https://websiteoss.ecoflow.com/upload/image/1744104788229/charger_section3_6.svg',
                },
                {
                    title: t('product1_icon_title_7'),
                    desc: t('product1_icon_desc_7'),
                    icon: 'https://websiteoss.ecoflow.com/upload/image/1744104789064/charger_section3_7.svg',
                },
                {
                    title: t('product1_icon_title_8'),
                    desc: t('product1_icon_desc_8'),
                    icon: 'https://websiteoss.ecoflow.com/upload/image/1744104789573/charger_section3_8.svg',
                },
                {
                    title: t('product1_icon_title_9'),
                    desc: t('product1_icon_desc_9'),
                    icon: 'https://websiteoss.ecoflow.com/upload/image/1744104789220/charger_section3_9.svg',
                },
                {
                    title: t('product1_icon_title_10'),
                    desc: t('product1_icon_desc_10'),
                    icon: 'https://websiteoss.ecoflow.com/upload/image/1744104789416/charger_section3_10.svg',
                },
            ],
        },
        {
            title: t('product_title_2'),
            desc: t('product_desc_2'),
            lChildren: t('product2_button_text'),

            pc: 'https://websiteoss.ecoflow.com/upload/image/1745293007377/image.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745293007585/image%20(1).jpg',
            link: 'https://jp.ecoflow.com/products/delta-3-1500-portable-power-station?variant=51809553744239',
            icons: [
                {
                    title: t('product2_icon_title_1'),
                    desc: t('product2_icon_desc_1'),
                    icon: 'https://websiteoss.ecoflow.com/upload/image/1744104788072/charger_section3_1.svg',
                },
                {
                    title: t('product2_icon_title_2'),
                    desc: t('product2_icon_desc_2'),
                    icon: 'https://websiteoss.ecoflow.com/upload/image/1744104788440/charger_section3_2.svg',
                },
                {
                    title: t('product2_icon_title_3'),
                    desc: t('product2_icon_desc_3'),
                    icon: 'https://websiteoss.ecoflow.com/upload/image/1744265808012/charger_section3_3.svg',
                },
                {
                    title: t('product2_icon_title_4'),
                    desc: t('product2_icon_desc_4'),
                    icon: 'https://websiteoss.ecoflow.com/upload/image/1744280417312/charger_section3_4.svg',
                },
                {
                    title: t('product2_icon_title_5'),
                    desc: t('product2_icon_desc_5'),
                    icon: 'https://websiteoss.ecoflow.com/upload/image/1744104788901/charger_section3_5.svg',
                },
                {
                    title: t('product2_icon_title_6'),
                    desc: t('product2_icon_desc_6'),
                    icon: 'https://websiteoss.ecoflow.com/upload/image/1744104788229/charger_section3_6.svg',
                },
                {
                    title: t('product2_icon_title_7'),
                    desc: t('product2_icon_desc_7'),
                    icon: 'https://websiteoss.ecoflow.com/upload/image/1744104789064/charger_section3_7.svg',
                },
                {
                    title: t('product2_icon_title_8'),
                    desc: t('product2_icon_desc_8'),
                    icon: 'https://websiteoss.ecoflow.com/upload/image/1744104789573/charger_section3_8.svg',
                },
                {
                    title: t('product2_icon_title_9'),
                    desc: t('product2_icon_desc_9'),
                    icon: 'https://websiteoss.ecoflow.com/upload/image/1744104789220/charger_section3_9.svg',
                },
                {
                    title: t('product2_icon_title_10'),
                    desc: t('product2_icon_desc_10'),
                    icon: 'https://websiteoss.ecoflow.com/upload/image/1744104789416/charger_section3_10.svg',
                },
            ],
        },
    ];

    useEffect(() => {
        const container = '.temp-section-2-container';
        const scrollHeight = !isMobile ? innerHeight - 46 : innerHeight - 46;
        if (!isMobile) {
            AniContainer.create({
                asyncFromTo: [
                    ['.temp-section-2-container .temp-section-2-box-2', { top: scrollHeight }, { top: 0 }, 0.001], // box1 视频秒现
                ],
                asyncTimeLine: [0.001],
                triggerElement: container,
                triggerHook: 1,
                offset: '100%',
                duration: '120%',
            });
        }
    }, []);

    return (
        <section className={`${styles.comp} temp-section-2`} id="section-2">
            <EcoSpace className="section-2-top-space" />
            <EcoSectionCommon title={t('title')} />
            <EcoSpaceSmall />
            <div className="temp-section-2-container">
                <div className="temp-section-2-sticky">
                    {productList?.map((boxItem, boxIndex) => (
                        <div key={boxIndex} className={`temp-section-2-box temp-section-2-box-${boxIndex + 1}`}>
                            <div className="temp-section-2-box-img">
                                <EFPicture src={boxItem?.pc} srcPad={boxItem?.h5} srcMobile={boxItem?.h5} />
                            </div>
                            <div className="temp-section-2-box-content">
                                <div className="temp-section-2-box-texts">
                                    <p className="temp-section-2-box-title">{boxItem?.title}</p>
                                    <p className="temp-section-2-box-desc">{boxItem?.desc}</p>
                                    {/* <p className="temp-section-2-box-btn">Buy now</p> */}
                                    <EcoButton
                                        lHref={boxItem.link}
                                        lChildren={boxItem?.lChildren}
                                        lRadius="ellipse"
                                        lDataLayer={{
                                            event: 'uaEvent',
                                            event_name: 'buy',
                                            product_name: boxItem?.title,
                                            position: `Product Detail`,
                                        }}
                                    />
                                </div>
                                <div className="temp-section-2-box-points">
                                    {boxItem?.icons?.map((iconItem, iconIndex) => (
                                        <div key={iconIndex} className="temp-section-2-box-point">
                                            <div className="temp-section-2-box-point-icon">
                                                <EFPicture src={iconItem?.icon} srcPad={iconItem?.icon} srcMobile={iconItem?.icon} />
                                            </div>
                                            <p className="temp-section-2-box-point-title">{iconItem?.title}</p>
                                            <p className="temp-section-2-box-point-desc">{iconItem?.desc}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
